import { Injectable, inject } from '@angular/core';

import { UserService } from '../user/user.service';
import { DebouncedAsyncDslResolver } from './debounced-async-dsl-resolver';
import { GetGroupAttributeRequest, GetGroupAttributeResponse } from './dsl.models';

@Injectable({
    providedIn: 'root',
})
export class DslUserGroupAttributeResolverService extends DebouncedAsyncDslResolver<GetGroupAttributeRequest, GetGroupAttributeResponse> {
    private readonly user = inject(UserService);

    protected get refPrefix(): string {
        return 'user.GetGroupAttribute';
    }

    protected get endpoint(): string {
        return 'asyncdsl/groupattribute';
    }

    protected createCacheKey(request: GetGroupAttributeRequest): string {
        return `${request.groupName}.${request.groupAttribute}.${this.user.username}`;
    }
}
